import { render } from "./AdminDateTime.vue?vue&type=template&id=5fd30616"
import script from "./AdminDateTime.vue?vue&type=script&lang=js"
export * from "./AdminDateTime.vue?vue&type=script&lang=js"

import "./AdminDateTime.vue?vue&type=style&index=0&id=5fd30616&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__